import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ToastModule, ToastPositionType } from 'primeng/toast';

@Component({
  selector: 'app-toast',
  standalone: true,
  imports: [CommonModule, ToastModule, TranslateModule],
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss'],
})
export class ToastComponent {
  public positions: { key: string; value: ToastPositionType }[] = [
    {
      key: 'bl',
      value: 'bottom-left',
    },
    {
      key: 'bc',
      value: 'bottom-center',
    },
    {
      key: 'br',
      value: 'bottom-right',
    },
    {
      key: 'c',
      value: 'center',
    },
    {
      key: 'tl',
      value: 'top-left',
    },
    {
      key: 'tc',
      value: 'top-center',
    },
    {
      key: 'tr',
      value: 'top-right',
    },
  ];
}
